import { ProductInfo } from '../store/types';

export const convertProductsToTable = (products: ProductInfo[]) => products.map((product) => ({
  ...product,
  key: product.id as number,
}));
